<div class="notifications-layout tw-relative">
    <div class="notifications-layout__content">
        <mon-breadcrumb [model]="breadcrumbItems" [showBreadcrumbs]="showBreadcrumbs"></mon-breadcrumb>
        <mon-page-layout 
        [header]="'notifications.page.header' | transloco"
        [subheader]="'notifications.page.subheader' | transloco:{ totalNotifications: totalCount }">
            <mon-table-wrapper
                [value]="notifications"
                [headers]="[TABLE_SCHEMA.NOTIFICATION, TABLE_SCHEMA.DATE]"
                [total]="totalCount"
                [currentPage]="page"
                [perPage]="pageSize"
                [loading]="loading"
                [emptyMessage]="'notifications.page.empty' | transloco"
                (page)="onPageChange($event)"
                tableKey="notifications">
                <ng-container *monTableCellTemplate="TABLE_SCHEMA.NOTIFICATION; let notification">
                    <p-button [link]="true" class="notifications-page__link tw-flex tw-gap-1 tw-no-underline tw-text-sm" (click)="redirect($event, notification)" (keyDown)="redirect($event, notification)">
                        <span>
                            {{ [notification.action, notification.target, notification.stage] | notificationAction }}
                            {{ [notification.target, notification.payload, notification.action] | notificationName }}
                        </span>
                    </p-button>
                </ng-container>
                <ng-container *monTableCellTemplate="TABLE_SCHEMA.DATE; let notification">
                    {{ notification.updated_at | date: 'medium' }}
                </ng-container>
            </mon-table-wrapper>
        </mon-page-layout>
    </div>
</div>
